import { ImageSourcePropType } from "react-native";

export function sanitizeImageSourceForElectron(
  imageSource?: ImageSourcePropType,
): ImageSourcePropType {
  // @ts-ignore This is done on purpose as it is not really a RN source
  if (imageSource?.default != null) {
    // @ts-ignore This is done on purpose as it is not really a RN source
    return imageSource.default;
  }
  // @ts-ignore Also done on purpose as it can be undefined, but we swallow it
  return imageSource;
}
